module.exports = __webpack_public_path__ + "media/images/district_m_logo-a9a6ea2bd74242e53a14bf691dfb7f64.png";